module.exports = __webpack_public_path__ + "img/404.e72c266a.png";